export const ru = {
    'choose-goal': 'Выберите цель',
    'conversion-must-be-set': 'Укажите ценность конверсии',
    'involved-sessions': 'Вовлеченные сессии',
    'less-then-min-conversion':
        'Ценность конверсии не может быть меньше {minConversion}{currencySymbol}',
    'more-then-max-conversion': 'Указана слишком большая ценность конверсии',
    'not-chosen-goal': 'Цель не выбрана',
    'unavailable-goal': 'Цель не найдена'
};
